import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EMPTY_ARRAY } from '../../../core/util/array';
import { FETCH_APPOINTMENTS } from '../../../constants/index';
import { DataLock } from '../../../core/util/dataLock';

const dataLock = new DataLock('');

export default (userProfileId: any) => {
  const dispatch = useDispatch();
  const pastAppointments = useSelector(
    (state: any) => state.account.pastAppointments || EMPTY_ARRAY
  );
  const upcomingAppointments = useSelector(
    (state: any) => state.account.upcomingAppointments || EMPTY_ARRAY
  );

  useEffect(() => {
    if (dataLock.isSameOrSet(userProfileId)) return;

    dispatch({
      type: FETCH_APPOINTMENTS,
      userProfileId,
    });
  }, [dispatch, userProfileId]);

  return { pastAppointments, upcomingAppointments };
};
